import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { LoginService } from 'src/app/core/services/login.service';
import { ProfileService } from '../../services/profile.service';
import { CommonServicesForAllModules } from 'src/app/shared/common/service';
import { ToastService } from 'src/app/core/toast.service';
import { Tables } from 'src/app/shared/enum/tables.enum';
import { ActivatedRoute } from '@angular/router';

export interface MembershipRegistration {
  id: string;
  community_id: string;
  supplier_id: string;
  membership_link?: string;
  status?: string;
  created_at?: string;
}
@Component({
  selector: 'app-membership-registration',
  templateUrl: './membership-registration.component.html',
  styleUrls: ['./membership-registration.component.scss']
})
export class MembershipRegistrationComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  loginDetails: any;
  filteredPartners: MembershipRegistration[] = [];
  pageSize: number = 10;
  pageIndex: number = 0;
  loading: boolean = false;
  private fetchSubscription?: Subscription;
  pageSizeOptions :any[] = [];
  directoryData: any;
   communityId: string | null = null;
   RegisterData:any

  registerForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private loginService: LoginService,
    private profileService: ProfileService,
    private commonService: CommonServicesForAllModules,
    private toast: ToastService
  ) {}

  ngOnInit(): void {

    this.loginDetails = this.loginService.getLoginData();

    this.route.params.subscribe(params => {
      this.communityId = params['id'] || null;
      console.log('Route param (communityId):', this.communityId);

      if (this.communityId && this.loginDetails?.type === 'SUPPLIER') {
        this.fetchCommunityRequests(); // call after param received
        this.fetchDirectoryById();
      }
    });

    this.registerForm = this.fb.group({
      membership_link: ['', Validators.required],
    });

  }

  ngOnDestroy(): void {
    this.fetchSubscription?.unsubscribe();
  }

  fetchDirectoryById(): void {
  const id = this.loginDetails?.id;
  const type = this.loginDetails?.type;

  if (!id || !type) return;

  this.profileService.getDirectoryByLoginType(id, type).subscribe({
    next: (directory) => {
      this.directoryData = directory;
      console.log('Fetched Directory Data:', this.directoryData);
    },
    error: (err) => {
      console.error('Error fetching directory:', err);
    },
  });
}

  fetchCommunityRequests(): void {
    if (!this.communityId) return;

    console.log('communityId---------', this.communityId)
this.loading = true;
    this.commonService
      .GetByField(Tables.Directories, 'community_id', this.communityId, ['membership_link'])
      .subscribe({
        next: (data:any) => {
          this.loading = false;
          console.log('object--------->', data);
          this.RegisterData = data
          console.log('RegisterData--------->', data);

        },
      });
  }

  //  Save new registration link
async saveRegistrationLink(): Promise<void> {
  if (this.registerForm.invalid) {
    this.toast.openSnackBar('Please enter a registration link.');
    return;
  }

  if (!this.directoryData?.community_id) {
    this.toast.openSnackBar('Community details not found. Please try again.');
    return;
  }

  try {
    this.loading = true;
    const link = this.registerForm.value.membership_link.trim();

    // Payloads for both tables
    const directoryPayload = { membership_link: link };

    if (this.directoryData?.id) {

         const isUpdate = this.directoryData.membership_link;
         
      await Promise.all([
        this.commonService.UpdateData(Tables.Directories,this.directoryData.id,directoryPayload)]
      );
      this.toast.openSnackBar(
      isUpdate
        ? 'Registration link updated successfully.'
        : 'Registration link saved successfully.'
    );
    } else {
      this.toast.openSnackBar('No existing partnership found to update.');
    }

    // Reset and refresh
    this.registerForm.reset();
    this.fetchCommunityRequests();
    this.fetchDirectoryById();
  } catch (err) {
    console.error('Error saving registration link:', err);
    this.toast.openSnackBar('Failed to update registration link.');
  } finally {
    this.loading = false;
  }
}


cancelRegistrationLink(){
  this.registerForm.get('membership_link')?.reset();
}



  //  Pagination
  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.fetchCommunityRequests();
  }
}
